var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-banner",class:_vm.className,style:(_vm.bannerStyle)},[_c('h2',{staticClass:"title f-8-cl"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }